import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';

export const GlobalLoadingOverlay = () => (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    role="dialog"
    aria-label="loading overlay"
  >
    <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
      <LoadingSpinner size="large" />
      <span className="mt-4 text-lg font-medium text-gray-700">טוען...</span>
    </div>
  </div>
);
